let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("5d0rS")).then(() => parcelRequire('ikxk8'));